import React, { useEffect, useState } from 'react';
import './index.less';

export const Suspension = () => {
  const [flag, setFlag] = useState(false);
  const [submenuVisible, setSubmenuVisible] = useState(false);
  const [hoveredItem, setHoveredItem] = useState(null);

  const toggleSubmenu = (visible) => {
    setSubmenuVisible(visible);
  };

  const handleMouseOver = (item) => {
    setHoveredItem(item);
  };

  const handleMouseOut = () => {
    setHoveredItem(null);
  };
  useEffect(() => {
    window.addEventListener('scroll', (e) => {
      if (document.documentElement.scrollTop >= 300) {
        setFlag(true);
      } else {
        setFlag(false);
      }
    });

    return () => {
      window.removeEventListener('scroll', () => {});
    };
  }, []);

  const goTop = () => {
    window.scrollTo(0, 0);
  };

  return (
    <div className="Suspension">
      {flag ? (
        <a className="back" onClick={goTop}>
          <img src="https://img.dsers.com/images/icon-back.svg" />
        </a>
      ) : null}
      {/* <a className="email" href="mailto:support@dserspro.com">
        <img src="https://img.dsers.com/images/icon-email.png" />
      </a>
      <a className="messenger" href="https://www.messenger.com/t/DSersOfficial">
        <img src="https://img.dsers.com/images/icon-messager.svg" />
      </a> */}
      <div
        className="hoverBox"
        onMouseOver={() => toggleSubmenu(true)}
        onMouseOut={() => toggleSubmenu(false)}
      >
        <div className="messenger" onClick={() => toggleSubmenu(!submenuVisible)}>
          <img src="https://img.dsers.com/marketing/Vector——2.0.png" />
          {submenuVisible && (
            <div
              className="submenu"
              onMouseOver={() => toggleSubmenu(true)}
              onMouseOut={() => toggleSubmenu(false)}
            >
              <div
                className="tipsPop"
                onMouseOver={() => handleMouseOver('tipspop')}
                onMouseOut={handleMouseOut}
                onClick={() => toggleSubmenu(false)}
                style={{
                  backgroundColor: hoveredItem === 'tipspop' ? '#fff3e0' : 'transparent',
                }}
              >
                <a
                  href="https://www.messenger.com/t/DSersOfficial"
                  target="_blank"
                  rel="noreferrer"
                >
                  <img
                    src="https://img.dsers.com/marketing/facebook-messenger-3.png"
                    alt=""
                    className="imgIcon"
                  />
                  Live Chat
                </a>
              </div>
              <div
                className="tipsPop"
                onMouseOver={() => handleMouseOver('tipsPop')}
                onMouseOut={handleMouseOut}
                onClick={() => toggleSubmenu(false)}
                style={{
                  backgroundColor: hoveredItem === 'tipsPop' ? '#fff3e0' : 'transparent',
                }}
              >
                <img
                  src="https://img.dsers.com/marketing/Frame_emial.png"
                  alt=""
                  className="imgIcon"
                />

                <a href="mailto:support@dserspro.com" target="_blank" rel="noreferrer">
                  Email
                </a>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
